export class AwaitableStream {
    messages;
    lastReadIndices;
    queues;
    constructor(){
        this.messages = [];
        this.lastReadIndices = new Map();
        this.queues = new Map();
    }
    emit(value) {
        this.messages.push(value);
        // For each queue, resolve the first promise that matches the condition
        for (const [callerName, queue] of Array.from(this.queues.entries())){
            for (const item of queue){
                if (item.condition(value)) {
                    item.resolve(value);
                    this.lastReadIndices.set(callerName, this.messages.length - 1);
                    queue.splice(queue.indexOf(item), 1);
                    return;
                }
            }
        }
    }
    async awaitFor(callerName, conditionFunction) {
        // If this is the first time this caller is reading a message, initialize their last read index and queue
        if (!this.lastReadIndices.has(callerName)) {
            this.lastReadIndices.set(callerName, -1);
            this.queues.set(callerName, []);
        }
        // Start from the message after the last one this caller read
        for(let i = (this.lastReadIndices.get(callerName) || -1) + 1; i < this.messages.length; i++){
            // If this message matches the condition
            if (conditionFunction(this.messages[i])) {
                // Update the last read index and return the message
                this.lastReadIndices.set(callerName, i);
                return this.messages[i];
            }
        }
        // If no unread message matches the condition, add a promise to the queue
        return new Promise((resolve, reject)=>{
            this.queues.get(callerName)?.push({
                resolve,
                condition: conditionFunction
            });
        });
    }
}
